<!-- 提成明细 -->
<template>
  <div class="commission-subsidiary">
    <div class="search">
      <span class="date-quantum" @click="show = true">
        {{selectedTime}}
        <cc-svg-icon :class-name="show ? 'icon-up':'icon-down'" icon-class="left-arrow" />
      </span>
    </div>
    <ul class="commission-subsidiary-list">
      <van-list
            v-model="m_loading"
            :finished="m_finished"
            :finished-text="m_finishedText"
            @load="mHandlePullUpLoadMore"
            :immediate-check="m_immediateCheck"
          >
        <cc-not-order
          v-if="list.length === 0 && m_loading === false"
          tip="亲，暂无相关订单哦"
          :show="false"
        >
        </cc-not-order>
        <cc-animation-list>
          <li v-for="(item,index) in list" :key="index">
            <div class="goods-title">
              <span>{{item.general_name}} {{item.norms}}</span>
            </div>
            <div class="goods-info">
              <div class="goods-info-front">
                <span>时间：{{item.post_date}}</span>
                <span >订单号：{{item.bid_price}}</span>
                <span >客户名称：{{item.customer_name}}</span>
              </div>
              <div class="goods-info-back">
                <span>单价：￥{{item.bid_price}}</span>
                <span>提成：{{item.feedback_money}}</span>
                <span>数量：{{item.quantity}}</span>
              </div>
            </div>
            <div class="goods-footer">
              提成小计：<span class="price font1">￥{{item.sum_feedback_money}}</span>
            </div>
          </li>
        </cc-animation-list>
      </van-list>
    </ul>
    <date-popup :show.sync="show" @loadData="setDate"/>
  </div>
</template>
<script>
import Vue from 'vue'
import DatePopup from '../components/date-popup'
import { loadSaleDetail } from '@/fetch/distributor'
import ListMixin from '@/mixins/list'
import { List } from 'vant'
Vue.use(List)
export default {
  mixins: [ListMixin],
  components: {
    DatePopup
  },
  props: {},

  data () {
    return {
      show: false,
      selectedTime: '',
      form: {
        start_time: '',
        end_time: ''
      },
      list: []
    }
  },

  computed: {},

  watch: {},

  created () {
  },

  methods: {
    getLastDay (year, month) {
      var newYear = year // 取当前的年份
      var newMonth = month++// 取下一个月的第一天，方便计算（最后一天不固定）
      if (month > 12) {
        newMonth -= 12 // 月份减
        newYear++ // 年份增
      }
      var newDate = new Date(newYear, newMonth, 1) // 取当年当月中的第一天
      return (new Date(newDate.getTime() - 1000 * 60 * 60 * 24)).getDate()// 获取当月最后一天日期
    },
    setDate (msg) {
      this.selectedTime = msg
      let reg = /\d*/g
      let dateArr = this.selectedTime.match(reg).filter(Boolean)
      let lastDay = this.getLastDay(dateArr[0], dateArr[1])
      let [startTime, endTime] = [`${dateArr[0]}-${dateArr[1]}-01`, `${dateArr[0]}-${dateArr[1]}-${lastDay}`]
      this.form.start_time = startTime
      this.form.end_time = endTime
      this.loadData(true)
    },
    async loadData (rest) {
      this.mRequest()
      if (rest) {
        this.list = []
        this.m_page.curr = 1
      }
      let param = {
        page: this.m_page.curr,
        page_size: this.m_page.limit,
        ...this.form,
        time_type: 5
      }
      let res = await loadSaleDetail(param)
      this.$tips(res, {
        tip: false
      }, res => {
        if (res.list.length === 0) {
          this.mEnd()
          if (this.list.length === 0) {
            this.m_finishedText = ''
          }
        } else {
          this.list = [...this.list, ...res.list]
        }
      })
      this.mSuccess()
    }
  }
}

</script>
<style lang='scss' scoped>
//修改日历插件的样式
.commission-subsidiary{
  padding:0 10px;
  &-list{
    li{
      background-color:#fff;
      margin-bottom: 3px;
      // height: 92px;
      box-sizing: border-box;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      border-radius: 10px 10px 0px 0px;
      .goods-title{
        color: #333333;
        border-bottom: 1px solid $border-color-base;
        padding: 0 10px;
        height:40px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        font-size: 14px;
        color: #333333;
        font-size: 14px;
      }
      .goods-info{
        color: #777777;
        font-size: 12px;
        display: flex;
        padding:6px 10px;
        justify-content: space-between;
        &-front{
          display: flex;
          flex-direction: column;
          span{
            display: inline-block;
            height: 23px;;
          }
        }
        &-back{
          display: flex;
          flex-direction: column;
          span{
            display: inline-block;
            height: 23px;;
          }
        }
      }
      .goods-footer{
        height: 40px;
        display: flex;
        justify-content:flex-end;
        align-items: center;
        margin: 0 10px;
        border-top: 1px solid $border-color-base;
        .price{
          font-size: 12px;
        }
      }
    }
  }
}
.font1{
  color: #333333;
}
.font2{
  color: #999999;
}
.sales-summary,.commission-subsidiary{
  .search{
    display:flex;
    justify-content: center;
    height: 40px;
    align-items: center;
    .date-quantum{
      border: 1px solid #DCDCDC;
      border-radius: 10px;
      color: #333333;
      background: #ffffff;
      padding: 3px 5px;
    }
    .icon-down{
      transform: rotate(-90deg) translate(2px,2px);
      color: #333333;
    }
    .icon-up{
      transform: rotate(90deg) translate(-2px,-2px);
      color: #333333;
    }
  }
}
</style>
